import { Component, HostListener, inject } from "@angular/core"
import { Router } from "@angular/router"
import { SidebarService } from "../../../core/services/sidebar-service/sidebar.service"
import { CommonModule } from "@angular/common"
import { getCookie } from "@auth/bp-pf-auth"
import { CommonService } from "../../../core/services/common/common.service"

@Component({
  selector: "app-sidebar",
  standalone: true,
  imports: [CommonModule],
  templateUrl: "./sidebar.component.html",
  styleUrl: "./sidebar.component.scss",
})
export class SidebarComponent {
  sidebarService = inject(SidebarService)
  commonService = inject(CommonService)
  router = inject(Router) // Assuming you have a router service injected

  ngOnInit() {
    // Close sidebar on mobile by default
    if (window.innerWidth < 768) {
      this.sidebarService.setMobile(true)
    }
  }

  toggleSidebar() {
    this.sidebarService.toggle()
  }

  closeSidebar() {
    if (this.sidebarService.isMobile()) {
      this.sidebarService.collapse()
    }
  }

  navigateTo(path: string): void {
    this.commonService.navigateToURLWithtenantCode(path);
  }

  @HostListener("window:resize", ["$event"])
  onResize(event: any) {
    const isMobile = event.target.innerWidth < 768
    this.sidebarService.setMobile(isMobile)
  }

  isActive(route: string): boolean {
    // Ensures the check is against the main part of the URL, ignoring query params
    const currentUrl = this.router.url.split('?')[0];
    // Checks if the current URL path contains the base route, accommodating nested routes
    return currentUrl.includes(route);
  }


  logout() {
    // Implement your logout logic here
    this.router.navigate(["/login"])
    localStorage.clear()
  }


}
